import { Card } from "PFComponents/card";
import PropTypes from "prop-types";
import React from "react";

export default class AdminListPage extends React.Component {
  render() {
    const { title, pagination, actions } = this.props;

    return (
      <div style={{ margin: 10 }}>
        <h1>
          {title}
          {actions && <div style={{ float: "right", marginBottom: 10 }}>{actions}</div>}
        </h1>
        <div style={{ clear: "both" }} />
        <Card>{this.props.children}</Card>
        {pagination}
      </div>
    );
  }
}

AdminListPage.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,

  actions: PropTypes.node,
  pagination: PropTypes.node
};

AdminListPage.defaultProps = {
  actions: null,
  pagination: null
};
